export default __webpack_public_path__ + "media/images/icons/icon_file_download-99cc9fe7a1a90b340c55e5d3860315bc.svg";